<template>
  <section>
    <!-- <h3 class="primary--text"><v-icon color="primary">business</v-icon> {{ $t('rol.title') }}</h3> -->
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          id-refresh="btn-refresh-rol"
        >
          <template slot="buttons">
            <v-tooltip bottom v-if="$store.state.permissions['roles:create']">
             <v-btn color="primary" dark
               @click.native.stop="openModal()"
               slot="activator"
             ><v-icon dark>add</v-icon> {{$t('common.add') }}</v-btn>
             <span>{{$t('rol.add')}}</span>
           </v-tooltip>
          </template>

          <template slot="form">
            <v-card-title class="headline">
              <v-icon>person</v-icon> {{ form.id ? $t('rol.crud.editRol') :  $t('rol.crud.addRol') }}
              <v-spacer></v-spacer>
              <v-btn flat small icon @click.native="$store.commit('closeModal')">
                <v-icon class="red--text">cancel</v-icon>
              </v-btn>
            </v-card-title>
            <v-form
              @submit.prevent="save"
              v-model="valid"
              ref="form"
              lazy-validation
              >
              <v-card-text>
                <v-container grid-list-md>

                <v-text-field
                  name="nombre"
                  :label="$t('rol.crud.name')"
                  id="nombre"
                  :rules="$validate(['required'])"
                  required
                  v-model="form.nombre"
                  maxlength="50"
                ></v-text-field>

                <v-text-field
                  name="path"
                  :label="$t('rol.crud.path')"
                  id="path"
                  v-model="form.path"
                  maxlength="100"
                ></v-text-field>

                <v-text-field
                  name="descripcion"
                  :label="$t('rol.crud.description')"
                  id="descripcion"
                  :rules="$validate(['required'])"
                  required
                  v-model="form.descripcion"
                ></v-text-field>

                </v-container>
                <log-datos :data="logDatos" v-if="logDatos"></log-datos>
              </v-card-text>
              <v-card-actions>
                <small class="error--text text-required">* {{$t('common.required_fields')}}</small>
                <v-spacer></v-spacer>
                <v-btn flat color="red"
                  @click.native="$store.commit('closeModal');">
                  <v-icon>close</v-icon> {{$t('common.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  type="submit"
                  :disabled="!valid">
                  <v-icon dark>check</v-icon> {{$t('common.save') }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </template>

          <template slot="items" slot-scope="items">
            <td class="nowrap">
              <v-tooltip bottom v-if="$store.state.permissions['roles:update']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="editItem(items.item.id, 'rol', dataGraphql)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip color="red" bottom v-if="$store.state.permissions['roles:delete']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="deleteItem(items.item.id, 'rol')">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
            <td>{{ items.item.nombre }}</td>
            <td>{{ items.item.descripcion }}</td>
            <td>{{ items.item.path }}</td>

          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>

import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import validate from '@/common/mixins/validate';
import LogDatos from '@/components/admin/usuario/LogDatos';
import logDatos from '@/components/admin/usuario/mixins/log-datos';

export default {
  mixins: [ crud, validate, logDatos ],
  data () {
    return {
      logDatos: null,
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'roles',
      headers: [
        { text: this.$t('common.actions'), sortable: false },
        { text: this.$t('rol.crud.name'), value: 'nombre' },
        { text: this.$t('rol.crud.description'), value: 'descripcion' },
        { text: this.$t('rol.crud.path'), value: 'path' }
      ],
      form: {
        nombre: '',
        path: '',
        descripcion: ''
      },
      dataGraphql: `
        id
        nombre
        path
        descripcion
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      filters: [],
      valid: true,
      tipos: [
        { text: 'ADMIN' },
        { text: 'CANCILLERIA' },
        { text: 'ENTIDAD' }
      ]
    };
  },
  methods: {
    openModal (data = {}) {
      this.$refs.form.reset();
      this.logDatos = null;
      if (data.id) {
        this.$nextTick(() => {
          this.logDatos = this.getLogDatos(data);
          this.form = data;
        });
      } else {
        this.form = {
          nombre: '',
          descripcion: ''
        };
      }
      this.$store.commit('openModal');
    },
    save () {
      if (this.$refs.form.validate()) {
        let data = Object.assign({}, this.form);
        if (data.id) {
          delete data.id;
          this.$service.graphql({
            query: `
              mutation edit($id: Int!, $rol: EditRol!) {
                rolEdit(id: $id, rol: $rol) {
                  id
                }
              }
            `,
            variables: {
              id: this.form.id,
              rol: data
            }
          }).then(response => {
            if (response) {
              this.$store.commit('closeModal');
              this.updateList('btn-refresh-rol');
              this.$message.success('Se actualizó el registro correctamente');
            }
          });
        } else {
          this.$service.graphql({
            query: `
              mutation add($rol: NewRol!) {
                rolAdd(rol: $rol) {
                  id
                }
              }
            `,
            variables: {
              rol: data
            }
          }).then(response => {
            if (response) {
              this.$store.commit('closeModal');
              this.updateList('btn-refresh-rol');
              this.$message.success();
            }
          });
        }
      }
    }
  },
  components: {
    CrudTable,
    LogDatos
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/preferencias/Rol.vue